<div class="zoid-container">
  <div class="zoid-content">
    <div [id]="appContainer"></div>
  </div>
</div>
